const getters = {
  roles: (state) => state.usuarios.roles,
  token: (state) => state.usuarios.token,
};
export default getters;
